export default "__VITE_ASSET__Dre$g9Nu__"